import styled from 'styled-components';

export const LinechartWrapper = styled.div`
  width: 100%;
  height: 250px;

  padding: 10px 36px 10px 36px;
`;
